const scrollToElement = (ref) => {
    setTimeout(() => {
        if (ref && ref.current)
            ref.current.scrollIntoView({ behavior: "smooth" });
    }, 200);
};

export { scrollToElement };
//# sourceMappingURL=scrollToElement.js.map
